import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import api from "@/services/api";

// Frontend defaults — mirror backend SETTINGS_DEFAULTS so the UI works even
// before /api/settings resolves.
const DEFAULTS = {
  text_modal_push: "Active les notifications pour ne rater aucun match pres de chez toi !",
  text_no_match: "Aucun match trouve pres de toi pour le moment. Sois le premier a en creer un !",
  search_radius_km: 20,
  maintenance_mode: false,
  max_days_advance: 14,
  max_players_limit: 22,
};

const SettingsContext = createContext({ ...DEFAULTS, refreshSettings: () => {} });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);

  const refreshSettings = useCallback(async () => {
    try {
      const s = await api.getSettings();
      if (s) setSettings({ ...DEFAULTS, ...s });
      return s;
    } catch (_) {
      return null;
    }
  }, []);

  useEffect(() => {
    refreshSettings();
  }, [refreshSettings]);

  const value = useMemo(() => ({ ...settings, refreshSettings }), [settings, refreshSettings]);

  return <SettingsContext.Provider value={value}>{children}</SettingsContext.Provider>;
}

export function useSettings() {
  return useContext(SettingsContext);
}
